import Vue from 'vue'
import VueApollo from 'vue-apollo'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import ApolloClient from 'apollo-boost'
import router from './router'
import VuePhoneNumberInput from 'vue-phone-number-input';
import { MonthPicker } from 'vue-month-picker'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('v-phone', VuePhoneNumberInput)
Vue.component('month-picker', MonthPicker)
//Vue.use(MonthPicker)
//Vue.use(MonthPickerInput)

const apolloClient = new ApolloClient({
  uri: `${process.env.VUE_APP_BACKEND}/ql`,
  request: function (op) {
    op.setContext({
      headers: {
        '_session_': localStorage.getItem('_session_')
      }
    })
  }
});
	
	
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(VueApollo)
Vue.config.productionTip = false

new Vue({
  vuetify,
  apolloProvider,
  router,
  render: h => h(App)
}).$mount('#app')
